const format = {
  name: 'visual-test-placeholder.svg',
  alternativeText: 'Placeholder',
  caption: null,
  width: 600,
  height: 400,
  url: '/images/visual-test-placeholder.svg',
  hash: 'visual-test-placeholder',
  ext: '.svg',
  mime: 'image/svg+xml',
  size: 0.57,
  previewUrl: null,
  provider: 'aws-s3',
  provider_metadata: null,
  createdAt: '2024-01-01T00:00:00.000Z',
  updatedAt: '2024-01-01T00:00:00.000Z',
};

const iconFormat = {
  name: 'visual-test-icon.svg',
  alternativeText: 'Icon',
  caption: null,
  width: 36,
  height: 36,
  url: '/images/visual-test-icon.svg',
  hash: 'visual-test-icon',
  ext: '.svg',
  mime: 'image/svg+xml',
  size: 0.57,
  previewUrl: null,
  provider: 'aws-s3',
  provider_metadata: null,
  createdAt: '2024-01-01T00:00:00.000Z',
  updatedAt: '2024-01-01T00:00:00.000Z',
};

export const MOCK_IMAGE = {
  image: {
    data: {
      attributes: {
        ...format,
        formats: {
          large: format,
          medium: format,
          small: format,
          thumbnail: format,
        },
      },
    },
  },
};

export const MOCK_ICON = {
  image: {
    data: {
      attributes: {
        ...iconFormat,
        formats: {
          large: iconFormat,
          medium: iconFormat,
          small: iconFormat,
          thumbnail: iconFormat,
        },
      },
    },
  },
};

export const mockRichText = (text: string) => ({
  text: [
    {
      type: 'paragraph',
      children: [
        {
          type: 'text',
          text,
        },
      ],
    },
  ],
});

export const MOCK_RICHTEXT = mockRichText(
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
);

export const MOCK_LINK = {
  text: 'Learn more',
  url: '#',
  variant: 'filled',
  color: 'primary',
};
